import { z } from 'zod';
export const unlockAccountRequestParamsSchema = z.object({
    accountId: z.string(),
});
export const unlockAccountResponseSchema = z.void();
